import { memo } from "react"
import cn from "clsx"
import styles from "./styles.module.scss"
import SbEditable from "storyblok-react"
import { imageService } from "utils"
import { render } from "storyblok-rich-text-react-renderer"
import type { HTMLAttributes } from "react"
import type { SbEditableContent } from "storyblok-react"
import type { Project as ProjectData } from "storyblok/schema"

interface ProjectProps
extends HTMLAttributes<HTMLLIElement>, SbEditableContent, ProjectData {}

const sizes = [175, 350, 700]

export const Project = memo<ProjectProps>(({
  client, organization, image, buzzWords, description, name,
  component, _uid, _editable,
  active, className, ...rest
}) => (
  <SbEditable content={{ component, _uid, _editable }}>
    <li {...rest} className={cn(styles.project, className)}>
      <picture className={styles.screenshot}>
        <source type="image/webp" srcSet={sizes.map(width => [
          imageService(image.filename, { resize: { width }, filter: { format: 'webp'}}),
          `${width}w`
        ].join(' ')).join(', ')} sizes="(min-width: 700px) 700px, 100vw" />
        <img sizes="(min-width: 700px) 700px, 100vw" decoding="async" 
          src={image.filename} 
          srcSet={sizes.map(width => [
            imageService(image.filename, { resize: { width }, filter: { format: 'jpeg'}}),
            `${width}w`
          ].join(' ')).join(', ')}
          alt="Screenshot" />
      </picture>
      <div className={styles.header}>
        <h3 className={styles.title}>{name}</h3>
        <p className={styles.client}>{client} @ {organization}</p>
      </div>
      <div className={styles.description}>{render(description)}</div>
      <ul className={styles.buzzwords}>
        {buzzWords.split(', ').map((buzz, index) => (
          <li key={index}>{buzz}</li>
        ))}
      </ul>
    </li>
  </SbEditable>
))

Project.displayName = 'ProjectItem'
